<p8-layout-settings-header [titlePath]="['Lien direct public de réponse à copier / coller pour le fournir aux demandeurs']"></p8-layout-settings-header>
<mat-card *ngIf="form.state === formState.published" style="margin-bottom: 5px;">
  <mat-card-subtitle>à mettre sur un portail, à envoyer par mail, etc au(x) demandeur(s) suceptible(s) d'effectuer une démarche sur ce formulaire</mat-card-subtitle>
  <mat-card-content>
    <div class="icon-text">
      <mat-icon>play_arrow</mat-icon>
      <span class="mat-body-2">{{formulaireSvc.formUrlDemandeurByForm(form)}}</span>
      <button mat-icon-button
              matTooltip="Copier le lien du formulaire."
              [cdkCopyToClipboard]="formulaireSvc.formUrlDemandeurByForm(form)" (cdkCopyToClipboardCopied)="linkCopied($event)" data-cy="button-url-form-copy">
        <mat-icon data-cy="icon-url-form-content-copy">content_copy</mat-icon>
      </button>
    </div>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="form.state !== formState.published" style="margin-bottom: 5px;">
  <mat-card-title>Le formulaire n'a pas été publié, aucun lien ne peut être fourni</mat-card-title>
</mat-card>

